import initStore from './initStore';
import actions from './actions';
import thunks from './thunks';

import { ICarePlanHospitalizationsModel } from './types';

const carePlanHospitalizations: ICarePlanHospitalizationsModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default carePlanHospitalizations;
